import { useMemo } from 'react';
import { enableServiceConnectionsUsageSdkAppIdBreakdown } from '@gonfalon/dogfood-flags/dogfood-flags';

import { DimensionType, UsageTab, type UsageTabKey } from '../../types';
import { usageTabConfig } from '../constants/usageTabConfig';

/**
 * Returns the available dimensions for a usage tab, filtered by feature flags.
 */
export function useFilteredDimensions(usageTab: UsageTabKey): DimensionType[] {
  const { dimensions } = usageTabConfig[usageTab];

  return useMemo(() => {
    // Filter out SDK_APP_ID from Service Connections if feature flag is disabled
    if (usageTab === UsageTab.SERVICE_CONNECTIONS && !enableServiceConnectionsUsageSdkAppIdBreakdown()) {
      return dimensions.filter((dim) => dim !== DimensionType.SDK_APP_ID);
    }
    return dimensions;
  }, [usageTab, dimensions]);
}
